import ScrollableContainer from "@components/shared/ScrollableContainer";
import { array, bool } from "prop-types";
import React, { useState } from "react";

import UpsellCarouselItem from "./UpsellCarouselItem";
import CircularLoader from "@components/shared/Icons/CircularLoader";

import { useIsMounted } from "@hooks/useIsMounted";

import { CUSTOMIZE_TYPES } from "@shared/constants";

const UpsellCarousel = ({ isReadOnly, options }) => {
  const [isWorking, setIsWorking] = useState(false);
  const isMounted = useIsMounted();

  return (
    <div className="relative">
      {isWorking && (
        <div className="absolute inset-0 grid place-items-center z-11 bg-primaryLight/80">
          <CircularLoader
            strokeWidth={10}
            className="size-16 text-primaryOrange"
          />
        </div>
      )}
      <ScrollableContainer className={{ inner: "py-4" }} isVisible={isMounted}>
        {options.map((option, index) => {
          const { item, selected, type } = option;
          const key = [
            type,
            type === CUSTOMIZE_TYPES.ACCESSORY
              ? item.officialReference
              : item.id,
          ].join("-");

          return (
            <UpsellCarouselItem
              index={index}
              isReadOnly={isReadOnly}
              item={item}
              key={key}
              isSelected={selected}
              setIsWorking={setIsWorking}
              type={type}
            />
          );
        })}
      </ScrollableContainer>
    </div>
  );
};

UpsellCarousel.propTypes = {
  isReadOnly: bool,
  options: array,
};

export default UpsellCarousel;
